export default __webpack_public_path__ + "static/media/DFPLiHei-Bd.de447f76.ttf";